import { supabase } from '@/lib/supabaseClient';

/**
 * Роль текущего пользователя.
 *
 * Нужна ровно для одного: показывать ли пункт «Админка». Решением это не
 * является — каждую административную операцию проверяет сервер, а роль
 * в профиле меняет только он (триггер запрещает правку поля клиентом).
 */
export type ProfileRole = 'user' | 'admin';

export async function fetchProfileRole(): Promise<ProfileRole> {
  if (!supabase) {
    return 'user';
  }

  const { data, error } = await supabase.from('profiles').select('role').maybeSingle();

  // Не удалось узнать — считаем обычным пользователем: лишний пункт меню
  // хуже отсутствующего, потому что ведёт на экран с отказом.
  if (error || !data) {
    return 'user';
  }

  return (data as { role: ProfileRole }).role === 'admin' ? 'admin' : 'user';
}
